import { useContext } from "react"
import { BsPersonVideo3 } from "react-icons/bs"
import { MdOutlineMenu } from "react-icons/md"
import { useHistory } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { Routes } from "src/constants"
import { SDKContext } from "src/context/SDKContext"
import { journeyUiSelector } from "src/recoil/atoms/journeyUI"
import { LuSettings, LuPackageOpen, LuLogOut } from "react-icons/lu"
import axios from "src/shared/axios"
import { MenuIconBtn } from "../menuIconBtn"
import { Popover, PopoverContent, PopoverTrigger } from "../popover"
import * as CSS from "csstype"
import { ResponsiveValue } from "@chakra-ui/react"

function HamburgerNavMenu({
  color,
  transparant,
  items,
  linkColor,
  bgColor = "transparent",
  top,
  right,
  position,
  popoverBg
}: {
  color: string
  transparant?: boolean
  items: ("plans" | "logout" | "avatar" | "account")[]
  linkColor?: string
  bgColor?: string
  popoverBg?: string
  top?: ResponsiveValue<CSS.Property.Top>
  right?: ResponsiveValue<CSS.Property.Right>
  position?: ResponsiveValue<CSS.Property.Position>
}) {
  const history = useHistory()
  const setJourneyUi = useSetRecoilState(journeyUiSelector)
  const meetingClient = useContext(SDKContext)

  const historyMethod = [Routes.PLANS, Routes.ACCOUNT].includes(history.location.pathname) ? history.replace : history.push

  const logout = async () => {
    const res = await axios.post(
      meetingClient?.envConfig.USER_LOGOUT,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
    if (res.status == 200) {
      history.replace(Routes.LOGIN)
    }
  }

  return (
    <Popover>
      <PopoverTrigger
        color="#ccc"
        pos={position ?? "fixed"}
        top={top ?? { base: "16px", sm: "32px" }}
        right={right ?? { base: "16px", sm: "32px" }}
        bgColor={bgColor}
        p={bgColor !== "transparent" ? "6px" : "0px"}
        borderRadius="4px"
        border="1px solid #ccc"
      >
        <MdOutlineMenu color={color} size={24} />
      </PopoverTrigger>
      <PopoverContent
        sideOffset={6}
        alignOffset={0}
        align="end"
        color={popoverBg ?? "#fff"}
        {...(transparant ? { "data-transparant": "true" } : {})}
      >
        {items.includes("avatar") && (
          <MenuIconBtn
            title="Avatars"
            logo={<BsPersonVideo3 color={linkColor ?? "white"} size={18} />}
            onClick={() => {
              setJourneyUi({
                transition: "journeyToExternal",
                externalRoute: "/avatars?go_back=journey"
              })
            }}
            color={linkColor ?? "white"}
          />
        )}
        {items.includes("account") && (
          <MenuIconBtn
            title="Account"
            logo={<LuSettings color={linkColor ?? color} size={18} />}
            onClick={() => {
              if (history.location.pathname === Routes.JOURNEY) {
                setJourneyUi({
                  transition: "journeyToExternal",
                  externalRoute: "/account?go_back=journey"
                })
              } else {
                historyMethod(Routes.ACCOUNT)
              }
            }}
            color={linkColor ?? color}
          />
        )}
        {items.includes("plans") && (
          <MenuIconBtn
            title="Subscriptions"
            logo={<LuPackageOpen color={linkColor ?? color} size={18} />}
            onClick={() => {
              if (history.location.pathname === Routes.JOURNEY) {
                setJourneyUi({
                  transition: "journeyToExternal",
                  externalRoute: "/plans?go_back=journey"
                })
              } else {
                historyMethod(Routes.PLANS)
              }
            }}
            color={linkColor ?? color}
          />
        )}
        {items.includes("logout") && (
          <MenuIconBtn
            title="Logout"
            logo={<LuLogOut color={linkColor ?? color} size={18} />}
            onClick={logout}
            color={linkColor ?? color}
          />
        )}
      </PopoverContent>
    </Popover>
  )
}

export default HamburgerNavMenu
